import { call } from 'redux-saga/effects'
import reqProvider from '../coreRequests'
import { BASE_API } from '../urlPaths'

export function* deleteUser(userID: string): any {
  const path = `${BASE_API}/users/${userID}`
  const data: any = yield call(reqProvider.deleteReq, path)
  return data ? true : false
}
